export const cancelSubscriptionLoading = ({store}) => store.cancelSubscriptionReducer.loading;

export const cancelSubscriptionError =  ({store})  => store.cancelSubscriptionReducer.error;

export const cancelSubscriptionData =  ({store})  => store.cancelSubscriptionReducer.data;